/* global Sys, Services */
Sys.ns("Services");

/**
 * The Response Service keep and publish the responses received from server.
 *
 * @class Services.Response
 * @extends Services.Base
 */
Services.Response = {
    BASIC_GAME_ACTIONS: [
        "spin",
        "respin",
        "init",
        "rcinfo",
        "rcreset",
        "widgetspin",
        "paytable"
    ],

    constructor: function(config) {
        Services.Response.superclass.constructor.apply(this, arguments);
        this._initResponse = config.initResponse;
        this._serverResponse = config.initResponse;
    },

    /**
     * Attach event listener for Services.Response.
     *
     * @private
     * @returns {void}
     */
    _setupEvents: function() {
        this.observable.on({
            "notify:responseParser.responseParsed": this._onResponseParsed.bind(this)
        });
    },

    /**
     * Init response received from server.
     *
     * @returns {Object} Init response received from server.
     */
    getInitResponse: function() {
        return this._initResponse;
    },

    /**
     * Recent response received from server.
     *
     * @returns {Object} Recent response received from server.
     */
    getServerResponse: function() {
        return this._serverResponse;
    },

    /**
     * Adds action to list of actions that belong to basic game.
     *
     * @param {string} action Action name.
     * @returns {void}
     */
    addBasicGameAction: function(action) {
        if (this.BASIC_GAME_ACTIONS.indexOf(action) < 0) {
            this.BASIC_GAME_ACTIONS.push(action);
        }
    },

    /**
     * Sets the list of actions that belong to basic game.
     *
     * @param {Array<string>} actions Array of actions.
     * @returns {void}
     */
    setBasicGameActions: function(actions) {
        this.BASIC_GAME_ACTIONS = actions;
    },

    /**
     * Triggered when server response is parsed and used to save the response.
     *
     * @param {Object} serverResponse – parsed server response.
     * @private
     * @returns {void}
     */
    _onResponseParsed: function(serverResponse) {
        this._serverResponse = serverResponse;
        this.publish("response", serverResponse);

        if (serverResponse.restore === true) {
            this.publish("restored", serverResponse);
        }
    },

    /**
     * Shows if next action is a bonus game action.
     *
     * @returns {boolean} True if nextaction does not belong to basic game.
     */
    isNextActionBonus: function() {
        return this.BASIC_GAME_ACTIONS.indexOf(this._serverResponse.nextaction) === -1;
    },

    /**
     * Shows if next action is spin action.
     *
     * @returns {boolean} True if nextaction equals spin.
     */
    isNextActionSpin: function() {
        return this._serverResponse.nextaction === "spin";
    }
};

Services.Response = Sys.extend(Services.Base, Services.Response, "Services.Response");
